<div class="message info" [ngClass]="!isInLiteMode && options.isDryRun ? '' : 'hide-height'">
    <span class="message-text">Please note: Dry run is currently switched on.</span>
    <span class="label-right">
    <button (click)="saveDryRun()">Switch off</button>
    <i class="bhi-info"></i>
  </span>
</div>
